/* global globalThis */
import React from 'react';
import PropTypes from 'prop-types';
import { CNavLink } from "./c/CHeader";
import { Tooltip, ListItem, ListItemText, Box } from "@material-ui/core";
import { useLogout } from 'sdk/custom-hooks';
import { MOBILE_MAX_WIDTH } from '../../../constants/breakpoints';

/**
 * MobileMenuList
 * @param props
 * @returns {*}
 * @constructor
 */
function MobileMenuList(props) {
    const { t, openDrawerStatus, screenWidth, handleDrawerClose, openFeedbackModel } = props;
    const logout = useLogout();
    const shouldCloseDrawerOnMobile = Boolean(screenWidth && screenWidth <= MOBILE_MAX_WIDTH);

    const closeDrawerOnMobile = () => {
      if (shouldCloseDrawerOnMobile) {
        handleDrawerClose();
      }
    };

    const handleFeedbackClick = () => {
      closeDrawerOnMobile();
      openFeedbackModel();
    };


    return (
        <React.Fragment>
            <CNavLink to="/my-profile">
                <Tooltip placement="right-end" title={openDrawerStatus ? '' : 'Settings'} aria-label="Settings">
                <ListItem button onClick={closeDrawerOnMobile}>
                        <i className="fa fa-cog m-r-18"/>
                        <ListItemText primary={t('settings')}/>
                    </ListItem>
                </Tooltip>
            </CNavLink>

            <Box>
                <Tooltip placement="right-end" title={openDrawerStatus ? '' : 'Feedback'} aria-label="Feedback"
                         className="bottom-link">
                <ListItem button onClick={handleFeedbackClick}>
                        <i className="fa fa-comments-o m-r-16"/>
                        <ListItemText primary={t('feedback')}/>
                    </ListItem>
                </Tooltip>
            </Box>
            <Box onClick={logout}>
                <Tooltip placement="right-end" title={openDrawerStatus ? '' : 'Logout'} aria-label="Logout"
                         className="bottom-link">
                <ListItem button onClick={closeDrawerOnMobile}>
                        <i className="fa fa-sign-out m-r-18"/>
                        <ListItemText primary={t('logout')}/>
                    </ListItem>
                </Tooltip>
            </Box>
        </React.Fragment>
    );
}

      MobileMenuList.propTypes = {
        t: PropTypes.func.isRequired,
        openDrawerStatus: PropTypes.bool,
        screenWidth: PropTypes.number,
        handleDrawerClose: PropTypes.func,
        openFeedbackModel: PropTypes.func
      };

export default MobileMenuList;
